<ui-table [responsive]="false" [rows]="tickets()">
  <div name="created-at" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.SRM_TICKET_DATE }}
    </ng-template>
    <ng-template let-ticket="item" uiTableCell>
      {{ ticket.createdAt | luxonDate }}<br>
      <small>{{ ticket.createdAt | luxonDate: "T" }} Uhr</small>
    </ng-template>
  </div>
  <div name="ticket-subject" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.SRM_TICKET_SUBJECT }}
    </ng-template>
    <ng-template let-ticket="item" uiTableCell>
      <a [link]="ticket" uiSrmTicketLink>{{ ticket.title }}</a>
    </ng-template>
  </div>
  <div name="ticket-number" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.SRM_TICKET_NUMBER }}
    </ng-template>
    <ng-template let-ticket="item" uiTableCell>
      @if (ticket.crmIdentifier) {
        <a [link]="ticket" uiSrmTicketLink>{{ ticket.crmIdentifier }}</a>
      } @else {
        -
      }
    </ng-template>
  </div>
  <div name="ticket-status" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.SRM_TICKET_STATUS }}
    </ng-template>
    <ng-template let-ticket="item" uiTableCell>
      <ui-srm-ticket-status [status]="ticket.status"></ui-srm-ticket-status>
    </ng-template>
  </div>
  <div name="actions" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.ACTIONS }}
    </ng-template>
    <ng-template let-ticket="item" uiTableCell>
      <div class="srm-actions">
        <a [link]="ticket" mat-icon-button uiSrmTicketLink matTooltip="Details anzeigen" matTooltipPosition="above">
          <ui-icon faName="eye" faStyle="light"></ui-icon>
        </a>
      </div>
    </ng-template>
  </div>
</ui-table>
